import { render, staticRenderFns } from "./ManageHistory.vue?vue&type=template&id=579f3132"
import script from "./ManageHistory.vue?vue&type=script&lang=js"
export * from "./ManageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports